import clsx from 'clsx';
import { AlertNotification } from '@alf/uikit';
import { useThemeComponents } from '@namespace/themes';

import styles from './index.module.css';

const DefaultToast = (props) => {
  const { isShortToast = false, ...rest } = props;
  const { DefaultToast: PartnerDefaultToast } = useThemeComponents();

  if (PartnerDefaultToast) {
    return <PartnerDefaultToast {...props} />;
  }

  return (
    <AlertNotification
      classNames={{
        messageClassName: clsx([styles.fixed, isShortToast && styles.toast])
      }}
      {...rest}
    />
  );
};

export default DefaultToast;
